import { useGetTimingServiceStatusQuery } from "~/generated/graphql";
import { InitializeTimingServiceStatusButton } from "../../InitializeTimingServiceStatusButton";
import { TimingServiceStatusIndicator } from "./TimingServiceStatusIndicator";

export const TimingServiceStatusIndicatorWrapper = (props: { collapsed: boolean }) => {
  const { collapsed } = props;
  const { data } = useGetTimingServiceStatusQuery();

  if (!data) {
    return <InitializeTimingServiceStatusButton />;
  }

  return <TimingServiceStatusIndicator collapsed={collapsed} />;
};
